import React from 'react';
import { Link, withRouter, RouteComponentProps } from "react-router-dom";
import Masonry from 'react-masonry-component'
import { useTranslation } from 'react-i18next'

import { ITour } from '../../../store'

interface IToursProps {
    tours: ITour[]
}

export default withRouter(({ tours, location: { state } }: RouteComponentProps & IToursProps) => {
    const { i18n: { languages: [language] } } = useTranslation()
    return (
        <div className="item-list-wrapper clearfix">
            <Masonry className="item-list-container" >
                {tours.map((item: ITour) => {
                    return (
                        <div key={item.id} className="item" >
                            {
                                <div className="item-wrapper">
                                    <Link to={{
                                        pathname: `/${language}/${item.country.slug}/${item.location.regionSlug}/${item.location.citySlug}/${item.slug}`,
                                        state: {
                                            ...state,
                                            tourId: item.id
                                        }
                                    }}>
                                        <div className="item-image">
                                            <img src={item.image} alt={item.title} />
                                        </div>
                                        <div className="item-detail tour-item-detail">
                                            <h4>{item.title}</h4>
                                        </div>
                                    </Link>
                                    <button className="quick-tour">
                                        <img src={'/images/icons/icon-view-tour.png'} alt={'icon-view-tour'} onClick={()=> window.open(`https://${language}.360tourist.net/view-tour/${item.id}/${language}?vr=true`, '_blank')}/>
                                    </button>
                                </div>
                            }

                        </div>
                    )
                }
                )}
            </Masonry>
        </div>
    );
})